import { render, staticRenderFns } from "./NtpTable.vue?vue&type=template&id=7d7d3be9&"
import script from "./NtpTable.vue?vue&type=script&lang=js&"
export * from "./NtpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports